export default __webpack_public_path__ + "static/media/main-characters-padded.353cfc57.jpg";